import { instance } from "../apiBase/instance";
import { AirdropAllocationType, AirdropType, ResponseType } from "../type";
import { AirdropFilterEnum } from "../type/enum";

export const getAllAirdop = async (
  page: number,
  limit: number,
  type: AirdropFilterEnum,
  keySearch: string
): Promise<ResponseType<AirdropType>> => {
  const response = await instance.get(
    `api/airdrops?page=${page}&limit=${limit}&type=${type}&search=${keySearch}`
  );
  return response.data;
};
export const getAllJoinedAirdop = async (
  address: string,
  page: number,
  limit: number,
  keySearch: string
): Promise<ResponseType<AirdropType>> => {
  const response = await instance.get(
    `api/airdrops/joined-airdrops/${address}?page=${page}&limit=${limit}&search=${keySearch}`
  );
  return response.data;
};
export const getAirdopDetail = async (slug: string) => {
  const response = await instance.get(`api/airdrops/slug/${slug}`);
  return response.data.data;
};

export const getAirdropAllocation = async (
  airdropId: number,
  address: string
): Promise<AirdropAllocationType[]> => {
  const response = await instance.get(
    `api/airdrop-allocations/airdrop/${airdropId}/user/${address}`
  );
  return response.data.data;
};

export const updateTransaction = async (id: number, body: { txn: string }) => {
  const response = await instance.post(
    `api/airdrop-allocations/update-transaction/${id}`,
    body
  );
  return response;
};
